import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getActiveSettingsTab, SETTINGS_TABS } from "./settingsTabs";
import { pageTitleSx } from "../../constants/designTokens";

const INK_SOFT = "#475569";
const PRIMARY = "#2563EB";
const LINE = "#E2E8F0";
const BODY_FONT = '"Source Sans 3", sans-serif';

export const SettingsLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeKey = useMemo(() => getActiveSettingsTab(location.pathname), [location.pathname]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pb: 3 }}>
      <Box>
        <Typography component="h1" sx={pageTitleSx}>
          Settings
        </Typography>
        <Typography sx={{ fontFamily: BODY_FONT, fontSize: 14, color: INK_SOFT, mt: 0.5 }}>
          Manage pharmacy profile, banking, team, and compliance
        </Typography>
      </Box>

      <Box
        sx={{
          borderBottom: `1px solid ${LINE}`,
          bgcolor: "#FFFFFF",
          borderRadius: "12px 12px 0 0",
          px: { xs: 1, md: 1.5 },
          pt: 0.5,
        }}
      >
        <Tabs
          value={activeKey}
          onChange={(_, value: string) => {
            const tab = SETTINGS_TABS.find((item) => item.key === value);
            if (tab) navigate(tab.path);
          }}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 44,
            "& .MuiTab-root": {
              fontFamily: BODY_FONT,
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              minHeight: 44,
              color: INK_SOFT,
            },
            "& .Mui-selected": {
              color: `${PRIMARY} !important`,
            },
            "& .MuiTabs-indicator": {
              backgroundColor: PRIMARY,
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          {SETTINGS_TABS.map((tab) => (
            <Tab key={tab.key} value={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      <Box>
        <Outlet />
      </Box>
    </Box>
  );
};

export default SettingsLayout;
